import React, { createContext, useContext, useState } from "react";
const LoadingContext = createContext(undefined);
const LoadingProvider = ({ children }) => {
    // hooks
    const [label, setLabel] = useState("");
    const [loading, setLoading] = useState(false);
    const [animated, setAnimated] = useState(false);
    const [blocking, setBlocking] = useState(true);
    const [type, setType] = useState("player");
    const setLoadingLocal = (loading) => {
        setLoading(loading);
        setBlocking(true);
    };
    const setLoadingNonBlocking = (loading) => {
        setBlocking(false);
        setLoading(loading);
    };
    return (React.createElement(LoadingContext.Provider, { value: {
            loading,
            setLoading: setLoadingLocal,
            setLoadingNonBlocking,
            type,
            setType,
            animated,
            setAnimated,
            label,
            setLabel,
            blocking,
            setBlocking,
        } }, children));
};
const useLoading = () => {
    const loadingContext = useContext(LoadingContext);
    if (loadingContext === undefined) {
        throw new Error(`useLoading must be used within a LoadingProvider`);
    }
    return loadingContext;
};
export { LoadingContext, LoadingProvider, useLoading };
//# sourceMappingURL=LoadingContext.js.map